exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.site-logo[data-v-1eeb8698]{min-width:35px;min-height:auto\n}\n.dropdown-header[data-v-1eeb8698]{color:#22252c !important;font-size:14px;font-weight:bold;border-bottom:solid 1px #6c757d\n}\n.profile-avatar[data-v-1eeb8698]{border:2px solid #fff;overflow:hidden;border-radius:50%;margin-right:5px;max-width:100%\n}", ""]);

// exports
